module.exports = "/public/webpack/img/icon_help_hot_question90695cbf66f4dee92e93e3ee037634b0.png";